import { render, staticRenderFns } from "./PreiseAnfrageView.vue?vue&type=template&id=4ff18076"
import script from "./PreiseAnfrageView.vue?vue&type=script&lang=js"
export * from "./PreiseAnfrageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports